/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useFormik } from 'formik'
import { useAuth } from '../core/Auth'
import { useDispatch } from 'react-redux'
import { authLogin } from '../../../../redux/action/auth'
import { Button } from 'react-bootstrap'
import { getCards } from '../../../../redux/action/card'
import { auth } from '../../../../firebase'
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth'
import { generatePopup } from '../../../../utils/popup'
import { isFeatureEnabled } from '../../../../config'
import { getFunctions, httpsCallable } from 'firebase/functions'
const environment = process.env.REACT_APP_ENVIRONMENT;
// import {auth} from '../../../../firebase';
// import { GoogleAuthProvider, signInWithPopup} from 'firebase/auth'
// import { getUserByToken, login } from '../core/_requests'
// import { toAbsoluteUrl } from '../../../../_4threal/helpers'
// import { generatePopup } from '../../../../utils/popup' //omitted due to eslint warning
// import { useSelector } from 'react-redux' //omitted due to eslint warning

const loginSchema = Yup.object().shape({
  email: Yup.string().email('Wrong email format').required('Email is required'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)
  // const { saveAuth, setCurrentUser } = useAuth() //omitted due to eslint warning
  const { saveAuth } = useAuth()
  const dispatch = useDispatch()
  const navigate = useNavigate()


  const bgTransparent = { background: 'transparent' }

  const viewicon = {
    top: '50% ',
    transform: 'translateY(-50%)',
    right: '10px',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      if (loading) return;
      setLoading(true)
      try {
        //await signInWithEmailAndPassword(auth, values.email, values.password);
        dispatch(
          authLogin(
            {
              email: values.email,
              password: values.password,
            },
          )
        )
          .then((res) => {
            dispatch(getCards(50, 1, res.uid)).then((resp) => {
              navigate("/dashboard")
            })
          })
          .catch((error) => {
            setStatus(error?.response?.data?.message)
            // Handle the error here
          })

        setLoading(false)
      } catch (error) {
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const handleGoogleSignIn = async () => {
    setLoading(true)
    const provider = new GoogleAuthProvider()
    try {
      const result = await signInWithPopup(auth, provider)
      const user = result.user
      localStorage.setItem('userId', user.uid)
      await dispatch(getCards(50, 1, user.uid)).then((resp) => {
        navigate("/dashboard")
      })
    } catch (error: any) {
      console.error('Error during Google sign-in:', error)
      
      // Handle account linking errors - let Firebase handle this automatically
      if (error.code === 'auth/account-exists-with-different-credential') {
        // This should not happen with "Link accounts that use the same email" enabled
        // But if it does, inform the user they can sign in with either method
        console.log('Account exists with different credential:', error.email)
        generatePopup('info', 'Account linked successfully! You can now sign in with either method.')
      } else if (error.code === 'auth/popup-closed-by-user') {
        // User closed the popup, no action needed
        console.log('Google sign-in popup closed by user')
      } else {
        generatePopup('error', 'Failed to sign in with Google. Please try again.')
      }
    }
    setLoading(false)
  }

  const handleAppleSignIn = async () => {
    setLoading(true)
    const provider = new OAuthProvider('apple.com')
    provider.addScope('email')
    provider.addScope('name')
    try {
      const result = await signInWithPopup(auth, provider)
      const user = result.user
      localStorage.setItem('userId', user.uid)
      await dispatch(getCards(50, 1, user.uid)).then((resp) => {
        navigate("/dashboard")
      })
    } catch (error: any) {
      console.error('Error during Apple sign-in:', error)
      
      // Handle account linking errors - let Firebase handle this automatically
      if (error.code === 'auth/account-exists-with-different-credential') {
        // This should not happen with "Link accounts that use the same email" enabled
        // But if it does, inform the user they can sign in with either method
        console.log('Account exists with different credential:', error.email)
        generatePopup('info', 'Account linked successfully! You can now sign in with either method.')
      } else if (error.code === 'auth/popup-closed-by-user') {
        // User closed the popup, no action needed
        console.log('Apple sign-in popup closed by user')
      } else {
        generatePopup('error', 'Failed to sign in with Apple. Please try again.')
      }
    }
    setLoading(false)
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-start mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Welcome to Skanteq!</h1>
        <p className='font-dark1'>Sign in to your Skanteq account.</p>
      </div>
      {/* <div className='row g-3 mb-9'>
        <div className='col-md-6'>
        </div>
        <div className='col-md-6'>
        </div>
      </div> */}
      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <></>
      )}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6  font-dark1'>Email address</label>
        <input
          placeholder='Email'
          style={bgTransparent}
          {...formik.getFieldProps('email')}
          className={clsx(
            `form-control`,
            { 'border-red': formik.touched.email && formik.errors.email },
            {
              ' border-primary': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-5'>
        <div className='d-flex align-items-center justify-content-between mb-2'>
          <label className='form-label  font-dark1 fs-6 mb-0'>Password</label>
          <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold '>
            <div />
            <Link to='/auth/forgot-password' style={{ color: '#767676' }}>
              Forgot Password ?
            </Link>
          </div>
        </div>
        <div className='position-relative'>
          <input
            placeholder='password'
            type={passwordVisible ? 'text' : 'password'}
            style={bgTransparent}
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control bg-transparent ',
              {
                'border-red text-red': formik.touched.password && formik.errors.password,
              },
              {
                'border-primary': formik.touched.password && !formik.errors.password,
              }
            )}
          />

          {passwordVisible ? (
            <i
              style={viewicon}
              onClick={() => setPasswordVisible(!passwordVisible)}
              className='bi bi-eye-slash fs-5 position-absolute'
            ></i>
          ) : (
            <i
              style={viewicon}
              onClick={() => setPasswordVisible(!passwordVisible)}
              className='bi bi-eye fs-5 position-absolute'
            ></i>
          )}
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      <div className='fv-row mb-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input
            className='form-check-input '
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />

          <span className='font-dark1'>Remember this account</span>
          {/* {formik.touched.acceptTerms && formik.errors.acceptTerms && ( */}
          {/* <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors.acceptTerms}</span>
          </div>
      </div> */}
          {/* )} */}
        </label>
      </div>

      <div className='row align-items-center'>
        <div className='col-12'>
          <Button
            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary w-100 mb-3'
            disabled={loading || formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Login</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Signing in...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </Button>

          <div className='separator separator-content my-4'>
            <span className='w-125px text-gray-500 fw-semibold fs-7'>Or </span>
          </div>
          <Button
            type='button'
            className='btn btn-primary w-100 mb-3'
            onClick={() => navigate('/auth/registration')}
          >
            <span className='indicator-label'>Create a new Account</span>
          </Button>
          <Button
            type='button'
            className='btn btn-flex flex-center btn-light w-100 mb-3 border border-dark text-dark'
            onClick={handleGoogleSignIn}
            disabled={loading}
            style={{ backgroundColor: 'white' }}
          >
            <img alt='Logo' src='/media/icons/duotune/general/google.svg' className='h-20px me-3' />
            Continue with Google
          </Button>

          <Button
            type='button'
            className='btn btn-flex flex-center btn-light w-100 mb-3 border border-dark text-dark'
            onClick={handleAppleSignIn}
            disabled={loading}
            style={{ backgroundColor: 'white' }}
          >
            <img alt='Logo' src='/media/icons/duotune/general/apple.svg' className='h-20px me-3' />
            Continue with Apple
          </Button>
          {environment !== 'production' && (
            <div className="text-center mt-4">
              <small className="text-muted">
                Team Demo: 
                <button
                  type="button"
                  className="btn btn-link btn-sm p-0 ms-1"
                  onClick={() => navigate('/auth/demo')}
                >
                  Compare Signup Flows
                </button>
                {" | "}
                <button
                  type="button"
                  className="btn btn-link btn-sm p-0"
                  onClick={() => navigate('/auth/legacy-registration')}
                >
                  Legacy Signup
                </button>
              </small>
            </div>
          )}
        </div>
      </div>
    </form>
  )
}
